import { Box, AppBar, Toolbar, Container, useTheme, IconButton } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import DriverFooter from './DriverFooter';
import { useTranslation } from 'react-i18next';
import { Logout as LogoutIcon } from '@mui/icons-material';
import LanguageSelector from '../LanguageSelector';

const DriverLayout = () => {
  const { signOut } = useAuth();
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh',
        bgcolor: theme.palette.background.default
      }}
    >
      {/* Header fixe */}
      <AppBar 
        position="fixed" 
        elevation={1}
        sx={{ 
          bgcolor: 'white',
          color: theme.palette.primary.main
        }}
      >
        <Toolbar sx={{ gap: 2, minHeight: '64px' }}>
          {/* Logo Container */}
          <Box 
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexGrow: 1,
              height: '64px',
              pl: 1
            }}
          >
            {/* Logo */}
            <Box 
              component="img"
              src="/logo-verifleet1.png"
              alt="VeriFleet"
              sx={{
                height: '32px', // Réduit de 40px à 32px
                width: 'auto',
                display: 'block',
                objectFit: 'contain'
              }}
            />
          </Box>
          
          {/* Actions */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {/* Sélecteur de langue */}
            <LanguageSelector 
              sx={{ 
                '& .MuiSelect-select': {
                  color: theme.palette.primary.main,
                  py: 1,
                  pl: 1,
                },
                '& .MuiSvgIcon-root': {
                  color: theme.palette.primary.main
                }
              }} 
            />
            
            {/* Bouton déconnexion */}
            <IconButton 
              onClick={handleLogout}
              aria-label={t('driver.logout')}
              title={t('driver.logout')}
              edge="end"
              sx={{ 
                color: theme.palette.primary.main,
                '&:hover': {
                  bgcolor: `${theme.palette.primary.light}20` // Légère opacité
                }
              }}
            >
              <LogoutIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Espace pour compenser l'AppBar fixe */}
      <Toolbar />

      {/* Contenu principal */}
      <Container 
        component="main" 
        sx={{ 
          flex: 1,
          py: 2,
          px: 2,
          mb: 7, // Espace pour le footer
          maxWidth: '100% !important'
        }}
      >
        <Outlet />
      </Container>

      {/* Footer de navigation fixe */}
      <DriverFooter />
    </Box>
  );
};

export default DriverLayout;